import React from 'react'
import dayjs from 'dayjs'


import { Item } from "../Item"

import { useCaseViewContext } from '../../context'

import {
    RequestHistoryItem,
    Timestamp,
    Title,
    RequestType,
    RequestStatus,
    DetailsMetric,
    DetailsValue,
    RequestDetailsContainer,
} from './Request.styles'

const LabCalculations = ({ calculations = {}, $bgColor }) => {
    if (!Object.keys(calculations).length) return null
    return (
        <RequestDetailsContainer $bgColor={$bgColor}>
            {
                Object.entries(calculations)
                    .filter(([key]) => !['createdAt', 'updatedAt', '_id'].includes(key))
                    .map(([key, metric]) => (
                    <div style={{ display: 'flex', flexDirection: 'column'}} key={key}>
                        <DetailsMetric>{metric?.name || 'Unknown'}</DetailsMetric>
                        <DetailsValue>{metric?.value || 'N/A'}</DetailsValue>
                    </div>
                ))
            }
        </RequestDetailsContainer>
    )
}

export const Request = ({ request, navigateToCase }) => {
    if (!request || typeof request !== 'object') return null
    
    const { caseDetails, activeRequest, apiClasses, apiType } = useCaseViewContext()

    const formattedDate = dayjs(request.timestamp).format('MM/DD/YYYY')

    const isActiveCase = (caseDetails?._id === request.caseId) || (caseDetails?.caseId === request.caseId)

    const isActiveRequest = isActiveCase && (
        activeRequest?._id === request._id ||
        (!activeRequest && request.requestType === 'initial')
    )

    const activeRequestBackgroundColor = 'rgba(123, 173, 126, 0.15)'
    const activeRequestTextColor = '#7BAD7E'
    const activeCaseBackgroundColor = 'rgba(204, 125, 203, 0.15)'
    const activeCaseTextColor = 'rgba(204, 125, 203, 1)'
    const otherCaseBackgroundColor = '#ddd'
    const otherCaseTextColor = '#000'

    const backgroundColor = isActiveRequest
        ? activeRequestBackgroundColor
        : isActiveCase
            ? activeCaseBackgroundColor
            : otherCaseBackgroundColor

    const color = isActiveRequest
        ? activeRequestTextColor
        : isActiveCase
            ? activeCaseTextColor
            : otherCaseTextColor


    const { labCalculations } = request

    return (
        <Item
            value={
                <RequestHistoryItem
                    $isactiverequest={isActiveRequest.toString()}
                    onClick={() => navigateToCase(request.caseId, request._id)}
                    $backgroundcolor={backgroundColor}
                >
                    <Timestamp>{formattedDate}</Timestamp>
                    <Title color={color}>{request.teleMedicineCategory}</Title>
                    <RequestType>{request.requestType} {request.requestType?.toLowerCase() !== 'rx change' && 'consultation'}</RequestType>
                    <RequestStatus>{request.status?.toLowerCase() || 'N/A'}</RequestStatus>
                    { labCalculations && <LabCalculations $bgColor={backgroundColor} $titleColor={color} calculations={labCalculations} /> }
                </RequestHistoryItem>
            }
        />
    )
}
